import { Check, Clock } from '@phosphor-icons/react';

import { ONBOARDING_STEP_LABELS } from '../../lib/onboardingCatalogs';
import pt from '../../locales/pt';
import { cn } from '../../utils/cn';
import { Button } from '../ui/Button';

/**
 * Desktop sage aside — brand, pitch, vertical step list, time note.
 * Visual target: Onboarding 1280 rail (sidebar 320) no .pen.
 */
export function OnboardingDesktopRail({ step, onLogout, logoutLabel }) {
  const copy = pt.onboarding.rail;
  const label = logoutLabel || pt.settings.hub.logout.title;

  return (
    <aside
      data-testid="onboarding-desktop-rail"
      className={cn(
        'flex h-full min-h-0 flex-col overflow-y-auto px-space-8 py-space-8 text-white',
        'bg-gradient-to-br from-sage-600 to-sage-800',
        'dark:from-[#3C5334] dark:to-[#2A3B26]',
      )}
    >
      <div className="flex items-start justify-between gap-space-3">
        <p className="type-title-card font-display font-bold tracking-tight">
          <span className="text-white/70">Ev</span>
          Planner
        </p>
        {onLogout ? (
          <Button
            type="button"
            variant="ghost"
            size="sm"
            onClick={onLogout}
            className="h-8 shrink-0 px-space-2 text-white/80 hover:bg-white/10 hover:text-white"
          >
            {label}
          </Button>
        ) : null}
      </div>

      <h2 className="type-title-page mt-space-6 font-display font-bold leading-tight tracking-tight">
        {copy.title}
      </h2>
      <p className="type-body-sm mt-space-2 leading-relaxed text-white/85">{copy.subtitle}</p>

      <nav className="mb-auto mt-space-6 flex flex-col gap-0.5" aria-label={copy.navLabel}>
        {ONBOARDING_STEP_LABELS.map((stepLabel, index) => {
          const stepNumber = index + 1;
          const done = stepNumber < step;
          const current = stepNumber === step;

          return (
            <div
              key={stepLabel}
              data-testid={`onboarding-rail-step-${stepNumber}`}
              data-state={current ? 'on' : done ? 'done' : 'upcoming'}
              className={cn(
                'flex items-center gap-space-3 rounded-ds-md px-space-2-5 py-space-2 type-body-sm text-white/70',
                current && 'bg-white/15 font-semibold text-white',
                done && 'text-white/[0.92]',
              )}
            >
              <span
                className={cn(
                  'flex h-[26px] w-[26px] shrink-0 items-center justify-center rounded-ds-full border-[1.5px] border-white/40 text-xs font-bold',
                  current && 'border-white bg-white text-sage-800',
                  done && 'border-transparent bg-white/28',
                )}
                aria-hidden
              >
                {done ? <Check className="h-3.5 w-3.5" weight="bold" /> : stepNumber}
              </span>
              <span>{stepLabel}</span>
            </div>
          );
        })}
      </nav>

      <p className="mt-space-4 flex items-center gap-space-2 type-label text-white/80">
        <Clock className="h-[15px] w-[15px] shrink-0" aria-hidden />
        {copy.duration}
      </p>
    </aside>
  );
}

export default OnboardingDesktopRail;
